// Theme context - Dark mode yönetimi
import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

// Theme context hook'u
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme hook ThemeProvider içinde kullanılmalıdır');
  }
  return context;
};

// Theme provider bileşeni
export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Local storage'dan tema tercihini al
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    
    // Sistem temasını kontrol et
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // Tema değişikliğini localStorage'a kaydet
  useEffect(() => {
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  // Tema değiştirme fonksiyonu
  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  // Açık tema ayarlama
  const setLightTheme = () => {
    setIsDarkMode(false);
  };

  // Koyu tema ayarlama
  const setDarkTheme = () => {
    setIsDarkMode(true);
  };

  const value = {
    isDarkMode,
    toggleTheme,
    setLightTheme,
    setDarkTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
